module.exports = __webpack_public_path__ + "img/db1fc7f.png";